import { useRPC } from "../../../hooks/useRPC/index.js";
import { ALL_REGIONS_ID } from "../constants.js";
import "react";
import { Skeleton } from "@therms/atalaya";
import { jsx } from "react/jsx-runtime";
// src/modules/Regions/shared/RegionName.tsx
var testData = { region: {
	active: true,
	id: "",
	name: "Test Region",
	timezone: ""
} };
var RegionName = ({ regionId }) => {
	const allRegions = regionId === ALL_REGIONS_ID;
	const { data, isCalling } = useRPC("regions::get-region-profile", { regionId }, {
		cacheStrategy: "cache-only",
		fire: !!regionId && !allRegions,
		testData
	});
	if (allRegions) return /* @__PURE__ */ jsx("span", { children: "All Regions" });
	if (!data?.region && isCalling) return /* @__PURE__ */ jsx(Skeleton.Text, { chars: 12 });
	if (!data?.region || !regionId) return null;
	return /* @__PURE__ */ jsx("span", { children: data.region.name });
};
export { RegionName };

//# sourceMappingURL=RegionName.js.map